<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>Vip资源列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索 -->
    <div class="content">
      <el-form
        inline
        :model="query"
        label-width="60px"
        label-position="right"
        size="small"
        class="query-form"
        @submit.native.prevent="getList()"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item
                label="来源"
                label-width="80px"
                style="margin-left: -15px"
              >
          <el-select
            v-model="query.origin"
            filterable
            clearable
            @change="selList()"
          >
            <el-option
              v-for="item in sourselist"
              :label="item.name"
              :value="item.id"
              :key="item.id"
              placeholder="请选择"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型" label-width="80px" style="margin-left:-15px;">
          <el-select v-model="query.enrolType" clearable placeholder="全部" @change="selList()" style="width: 100%;">
            <el-option label="新报" value="新报"></el-option>
            <el-option label="续费" value="续费"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="顾问" label-width="80px" style="margin-left:-15px;">
          <DeptRoleTeacherSelect v-model="query.adviserID" dept="日语" placeholder="请选择部门 → 角色 → 老师" @change="adviserClick()" />
        </el-form-item>
        <el-form-item label="营销" label-width="80px" >
          <DeptRoleTeacherSelect v-model="query.marketID" dept="日语" placeholder="请选择部门 → 角色 → 老师" @change="datelClick()" />
        </el-form-item>
        <el-form-item label="教学" label-width="80px" >
          <el-select
            v-model="query.teacherID"
            clearable
            placeholder="请选择教学老师"
            @change="datelClick()"
          >
            <el-option
              v-for="item in teacherlist"
              :label="item.realName"
              :value="item.userID"
              :key="item.userID"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学历" label-width="60px">
          <el-select v-model="query.eduBack" clearable filterable placeholder="请选择" @change="selList()">
            <el-option v-for="item in edubacklist" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所在地" label-width="70px">
          <el-select v-model="query.province" clearable filterable placeholder="请选择" @change="selList()">
            <el-option v-for="item in provinceList" :label="item.areaName" :value="item.areaName" :key="item.areaID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学生/家长" label-width="80px">
          <el-select v-model="query.studentType" clearable placeholder="请选择" @change="selList()">
            <el-option v-for="item in studentTypeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学习目的" label-width="80px">
          <el-select v-model="query.purpose" clearable filterable placeholder="请选择" @change="selList()">
            <el-option v-for="item in purposeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上课形式" label-width="80px">
          <el-select v-model="query.intendedForm" clearable placeholder="请选择" @change="selList()">
            <el-option v-for="item in intendedFormList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="缴费时间" label-width="80px">
          <el-date-picker
            v-model="query.daterange"
            @change="datelClick()"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList()">查询</el-button>
          <el-button type="success" @click="exportClick()">导出</el-button>
        </el-form-item>
      </el-form>

      <!-- 主体 -->
      <el-card class="box-card table">
        <div class="clearfix" slot="header">
          <span>Vip资源列表</span>
        </div>

        <!-- 列表 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width:100%"
          :default-sort="{ prop: 'payTime', order: 'descending' }"
          @sort-change="sortChange"
          @filter-change="filterTag"
        >
          <el-table-column prop="enrolType" label="类型" width="80">
            <template slot-scope="scope">
              <el-tag size="mini" :type="scope.row.isRenewal ? 'warning' : 'success'">{{ scope.row.enrolType || '新报' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="payTime" label="缴费时间" width="110"></el-table-column>
          <el-table-column prop="jpInputTime" label="添加时间" width="110"></el-table-column>
          <el-table-column prop="realName" label="姓名"></el-table-column>
          <el-table-column prop="wechat" label="微信"></el-table-column>
          <el-table-column prop="origin" label="来源"></el-table-column>
          <el-table-column prop="areaShow" label="地区"></el-table-column>
          <el-table-column prop="abroadDate" label="赴日时间" :width="100"></el-table-column>
          <!-- <el-table-column prop="intendedCourse" label="意向课程" :width="150"></el-table-column> -->
          <el-table-column prop="courseName" label="学习课程" :width="150"></el-table-column>
          <el-table-column prop="eduBack" label="学历" :width="100"></el-table-column>
          <el-table-column prop="classHour" label="课时数" :width="100"></el-table-column>
          <el-table-column prop="classForm" label="上课形式" :width="120"></el-table-column>
          <el-table-column prop="payAmount" label="缴费金额" :width="120">
            <template slot-scope="scope">
              <span>{{ (scope.row.latestCourseAmount > 0 ? scope.row.latestCourseAmount : (scope.row.payAmount || 0)).toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="learningPurpose" label="学习目的" :width="120"></el-table-column>
          <el-table-column prop="adviserName" label="顾问"></el-table-column>
          <el-table-column prop="marketName" label="营销"></el-table-column>
          <el-table-column prop="renewerName" label="续费人"></el-table-column>
          <el-table-column label="跟进状态" :width="150">
            <template slot-scope="scope">
              <OtherDeptFollow :row="scope.row" :show-jap="false" @show-follow="showFollowDialog" />
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <el-button-group v-if="showLimitedOpJap(scope.row)">
                <el-tooltip content="查看详情" placement="top">
                  <el-button
                    type="success"
                    size="mini"
                    icon="el-icon-view"
                    @click="japshowstuid=scope.row.studentID"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="分配" placement="top">
                  <el-button
                    type="info"
                    size="mini"
                    icon="el-icon-user-solid"
                    @click="assignClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="申请案例" placement="top" v-if="isMarketingOnlyJap(scope.row)">
                  <el-button type="danger" size="mini" icon="el-icon-notebook-1" @click="editClickFeel(scope.row)"></el-button>
                </el-tooltip>
              </el-button-group>
              <el-button-group v-else>
                <el-tooltip content="查看详情" placement="top">
                  <el-button
                    type="success"
                    size="mini"
                    icon="el-icon-view"
                    @click="japshowstuid=scope.row.studentID"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="分配" placement="top">
                  <el-button
                    type="info"
                    size="mini"
                    icon="el-icon-user-solid"
                    @click="assignClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="课程管理" placement="top" v-if="canEditJap(scope.row)">
                  <el-button type="warning" size="mini" icon="el-icon-user"
                    @click="openCourse(scope.row.studentID)"></el-button>
                </el-tooltip>
                <el-tooltip content="老学员续费" placement="top" v-if="canEditJap(scope.row)">
                  <el-button type="info" size="mini" icon="el-icon-refresh"
                    @click="renewClick(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip content="编辑" placement="top" v-if="canEditJap(scope.row)">
                  <el-button type="primary" size="mini" icon="el-icon-edit"
                    @click="editClick(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip content="申请案例" placement="top" v-if="canEditJap(scope.row)">
                  <el-button type="danger" size="mini" icon="el-icon-notebook-1" @click="editClickFeel(scope.row)"></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :size-page="pageSize"
            :current-page="currentPage4"
            :page-sizes="[10,20,30,50,100]"
            layout="total,sizes,prev,pager,next,jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 弹框 -->
    <el-dialog :title="form.id>0?'编辑Vip资源':''" :visible.sync="dialogVisible">
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm(form)"
      >
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="添加时间" prop="jpInputTime" :rules="[{required:true,message:'不能为空'}]">
              <el-date-picker
                v-model="form.jpInputTime"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                type="date"
                placeholder="选择时间"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="缴费时间" prop="payTime">
              <el-date-picker
                v-model="form.payTime"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                type="date"
                placeholder="选择缴费时间"
                style="width:100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item
              label="姓名"
              prop="realName"
              :rules="[
        {required:true,message:'请输入姓名'}
        ]"
            >
              <el-input v-model="form.realName" placeholder="请输入姓名"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item
              label="性别"
              prop="sex"
              :rules="[
        {required:true,message:'请选择性别'}
        ]"
            >
              <el-radio-group v-model="form.sex">
                <el-radio :label="true">男</el-radio>
                <el-radio :label="false">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="资源状态" prop="state" :rules="[{required:true,message:'不能为空'}]">
              <el-select v-model="form.state" clearable placeholder="请选择资源状态" filterable>
                <el-option
                  v-for="item in statelist"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="学历" prop="eduBack" :rules="[{required:true,message:'不能为空'}]">
              <el-select v-model="form.eduBack" clearable placeholder="请选择学历" filterable>
                <el-option
                  v-for="item in edubacklist"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="地区" :rules="[{required:true,message:'不能为空'}]">
              <el-cascader
                :options="arealist"
                v-model="selectedOptions"
                style="width:100%;"
                clearable
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="学习目的" prop="purpose">
              <el-select v-model="form.purpose" clearable placeholder="请选择学习目的" filterable>
                <el-option
                  v-for="item in purposelist"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item prop="wechat" label="微信">
              <el-input v-model="form.wechat" placeholder="请输入微信"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="qq" label="QQ">
              <el-input v-model="form.qq" placeholder="请输入QQ"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="10">
            <el-form-item label="来源" prop="origin">
              <el-select v-model="form.origin" clearable placeholder="请选择来源" filterable>
                <el-option
                  v-for="item in sourselist"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="japanese" label="日语状态">
              <el-select v-model="form.japanese" clearable placeholder="请选择日语状态">
                <el-option
                  v-for="item in japlist"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="上课形式" prop="classForm">
              <el-select v-model="form.classForm" clearable placeholder="请选择上课形式" style="width: 100%;">
                <el-option v-for="item in intendedFormList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="学习课程" prop="courseName">
              <el-input v-model="form.courseName" placeholder="请输入学习课程名称" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>


        <el-form-item label="电话" prop="mobile">
          <el-input v-model.number="form.mobile" type="number" placeholder="请输入联系电话"></el-input>
        </el-form-item>

        <div>
          <el-divider content-position="left" style="padding:10px 0px;">修改顾问/营销老师</el-divider>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="顾问老师" prop="adviserID" :rules="[{required:true,message:'请选择'}]">
                <DeptRoleTeacherSelect v-model="form.adviserID" dept="日语" placeholder="请选择部门 → 角色 → 老师" />
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="营销老师" prop="marketID">
                <DeptRoleTeacherSelect v-model="form.marketID" dept="日语" placeholder="请选择部门 → 角色 → 老师" />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-form-item label="续费人">
          <el-select v-model="form.renewerID" placeholder="不选则为当前顾问" clearable style="width:100%">
            <el-option
              v-for="item in renewerOptions"
              :label="item.realName"
              :value="item.userID"
              :key="item.userID"
            ></el-option>
          </el-select>
          <div style="color:#909399;font-size:12px;margin-top:4px;">选老师则算该老师签约，不选则当前顾问</div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    
    <!-- 2026-01升级：老学员续费对话框（与课程管理添加课程弹窗一致） -->
    <el-dialog title="老学员续费" :visible.sync="renewDialogVisible" width="800px">
      <el-form :model="renewForm" ref="renewFormRef" label-width="100px" :status-icon="true"
        @submit.native.prevent="submitRenew">
        <el-form-item prop="courseName" label="购买课程" :rules="[{required:true,message:'不能为空'}]">
          <el-input v-model="renewForm.courseName" placeholder="请输入课程名称"></el-input>
        </el-form-item>
        <el-form-item prop="payTime" label="缴费时间" :rules="[{required:true,message:'不能为空'}]">
          <el-date-picker
            v-model="renewForm.payTime"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="请选择时间"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>
        <el-form-item prop="coursePrice" label="全额费用">
          <el-input-number v-model="renewForm.coursePrice" :min="0" :precision="2" :step="0.01" style="width:100%"></el-input-number>
        </el-form-item>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item prop="amount1" label="一期">
              <el-input-number v-model="renewForm.amount1" :min="0" :precision="2" :step="0.01" style="width:100%"></el-input-number>
            </el-form-item>
            <el-form-item prop="phase1Date" label="一期日期">
              <el-date-picker v-model="renewForm.phase1Date" value-format="yyyy-MM-dd" type="date" placeholder="请选择日期" style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="amount2" label="二期">
              <el-input-number v-model="renewForm.amount2" :min="0" :precision="2" :step="0.01" style="width:100%"></el-input-number>
            </el-form-item>
            <el-form-item prop="phase2Date" label="二期日期">
              <el-date-picker v-model="renewForm.phase2Date" value-format="yyyy-MM-dd" type="date" placeholder="请选择日期" style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="amount3" label="三期">
              <el-input-number v-model="renewForm.amount3" :min="0" :precision="2" :step="0.01" style="width:100%"></el-input-number>
            </el-form-item>
            <el-form-item prop="phase3Date" label="三期日期">
              <el-date-picker v-model="renewForm.phase3Date" value-format="yyyy-MM-dd" type="date" placeholder="请选择日期" style="width:100%"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-form-item prop="percentage" label="顾问提成" :rules="[{required:true,message:'不能为空'}]">
          <el-input type="number" v-model.number="renewForm.percentage" placeholder="请输入数字"></el-input>
        </el-form-item> -->
        <el-form-item prop="classHour" label="课时数" :rules="[{required:true,message:'不能为空'}]">
          <el-input type="number" v-model.number="renewForm.classHour" placeholder="请输入课时"></el-input>
        </el-form-item>
        <el-form-item label="上课形式">
          <el-select v-model="renewForm.classForm" placeholder="请选择上课形式" style="width: 100%;" clearable>
            <el-option v-for="item in intendedFormList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="startTime" label="开始时间" :rules="[{required:true,message:'不能为空'}]">
          <el-date-picker
            v-model="renewForm.startTime"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="请选择开始时间"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>
        <el-form-item prop="endTime" label="结束时间" :rules="[{required:true,message:'不能为空'}]">
          <el-date-picker
            v-model="renewForm.endTime"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="请选择结束时间"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="教学老师">
          <el-select
            v-model="renewTeacherOptions"
            placeholder="请选择教学老师"
            multiple
            clearable
            style="width:100%"
          >
            <el-option
              v-for="item in teacherlist"
              :label="item.realName"
              :value="item.userID"
              :key="item.userID"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="续费人">
          <el-select v-model="renewForm.renewerID" placeholder="不选则为当前顾问续费" clearable style="width:100%">
            <el-option
              v-for="item in renewerOptions"
              :label="item.realName"
              :value="item.userID"
              :key="item.userID"
            ></el-option>
          </el-select>
          <div style="color:#909399;font-size:12px;margin-top:4px;">选老师则算该老师签约，不选则当前顾问自己续费</div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="renewSubmiting" native-type="submit">提交</el-button>
          <el-button @click="renewDialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 操作对话框 -->
    <el-dialog :title="'申请案例'" :visible.sync="dialogVisiblefeel"  @opened="dialogOpended()">
      <el-form :model="form" ref="form" label-width="100px" :status-icon="true"
        @submit.native.prevent="submitForm('form')">
       
         
        <el-form-item label="申请感受" prop="feel">
          <el-input v-model="form.feel" placeholder="请输入申请感受"></el-input>
        </el-form-item>
        <el-form-item label="合格通知书">
                <div id="uploadBtn1" class="uploader uploader-warning"></div>
                <div style="padding: 0px 10px">
                  
                  <div class="uploader-text">
                    <a v-if="form.book" 
                  :href="domain + form.book" 
                  target="_blank" 
                  style="color: #409eff; text-decoration: none;">
                    {{ form.book }}
                  </a>
                  </div>
                
                  
                </div>
              </el-form-item>
              <el-form-item
          label="合格通知书图片"
          :rules="[{ required: false, message: '不能为空' }]"
        >
          <div id="uploadBtnConfig" class="uploader uploader-warning"></div>
          <img
            id="relativeName"
            :src="domain + form.bookPhoto"
            style="height: 40px; position: relative; left: 10px; top: 20px"
            v-if="form.bookPhoto"
          />
          <span
            class="imgtext"
            title
            type="info"
            style="position: relative; left: 0px; top: 1px"
          ></span>
        </el-form-item>
        <el-form-item label="聊天截图" prop="pictures">
          <div id="uploadBtn" class="uploader uploader-warning"></div>

          <el-row :gutter="24">
            <el-col :span="12" v-for="(item, index) in imgList" :key="index">
              <el-card style="margin-top: 10px;text-align: center;">
                <img
                  :src="domain + item"
                  class="image"
                  style="max-height: 100px"
                />
                <div style="padding: 0px">
                  <div class="bottom clearfix">
                    <el-button-group>
                      <el-button
                        type="danger"
                        size="mini"
                        icon="el-icon-delete"
                        @click="deleteImg(index)"
                      ></el-button>
                    </el-button-group>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-form-item>
        <div style="height: 10px"></div>
        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisiblefeel = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 分配弹框（日语板块：可分配留学、鸣野，不显示分配给日语） -->
    <AssignResourceDialog
      :visible.sync="assignDialogVisible"
      :form="assignForm"
      :adviser-list="adviserlist"
      :market-list="marketlist"
      :user-is-admain="userIsAdmain"
      :show-student="true"
      :show-jap="false"
      :show-mingye="true"
      name-label="资源名称"
      empty-message="请选择分配给留学或鸣野"
      @success="getList"
    />
    <FollowDetailDialog :visible.sync="followDialogVisible" :type="followType" :row="followDialogRow" />
    <JapaneseShow :japstuid="japshowstuid" v-on:japsetzero="japshowstuid=0"></JapaneseShow>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import user from "@/plugins/user.js";
import JapaneseShow from "@/components/JapaneseShow";
import OtherDeptFollow from "@/components/OtherDeptFollow";
import DeptRoleTeacherSelect from "@/components/DeptRoleTeacherSelect.vue";
import FollowDetailDialog from "@/components/FollowDetailDialog";
import AssignResourceDialog from "@/components/AssignResourceDialog";
export default {
  data() {
    return {
      window: window,
      domain: url.getDomain(),
      userIsAdmain: user.isAdmin(), //管理员
      userIsAdviser: user.isAdviser(), //顾问老师
      userIsMarket: user.isMarket(), //营销老师
      query: { intendedForm: '', enrolType: '' }, // 上课形式、类型(新报/续费)等筛选项需初始化为响应式
      form: {},
      submiting: false,
      loading: false,
      dialogVisible: false,
      dialogVisiblefeel: false,//申请案例
      imgList:[],//聊天记录
      renewDialogVisible: false, // 2026-01升级：续费对话框
      renewForm: {}, // 2026-01升级：续费表单（与课程管理添加课程一致）
      renewTeacherOptions: [], // 续费弹窗所选教学老师
      renewerOptions: [], // 续费人可选列表：顾问老师+教务老师（GetRenewerOptions），选则算该老师签约
      renewSubmiting: false,
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage4: 1,
      marketlist: [], //营销老师
      adviserlist: [], //顾问老师
      courselist: [], //学习课程
      courseOptions: [],
      arealist: [], //省市
      selectedOptions: [],
      japlist: url.getJapLevelList(), // 日语状态（与 Common/鸣野 统一）
      sourselist: [], //来源
      edubacklist: url.getEduBack(), //学历
      studentTypeList: url.getStudentTypeList(), //学生/家长
      provinceList: [], //省份列表
      purposeList: url.getPurposeList(), //学习目的（筛选用）
      intendedFormList: url.getIntendedFormList(), //意向上课形式（筛选用）
      // edubacklist: [
      //   { id: "小学", name: "小学" },
      //   { id: "初中", name: "初中" },
      //   { id: "中专/高职", name: "中专/高职" },
      //   { id: "高中", name: "高中" },
      //   { id: "大专", name: "大专" },
      //   { id: "本科", name: "本科" },
      //   { id: "硕士", name: "硕士" },
      //   { id: "其他", name: "其他" }
      // ], //学历
      // sourselist: [
      //   { id: "知乎", name: "知乎" },
      //   { id: "微博", name: "微博" },
      //   { id: "后台", name: "后台" },
      //   { id: "公众号", name: "公众号" },
      //   { id: "B站", name: "B站" },
      //   { id: "抖音", name: "抖音" },
      //   { id: "网络搜索", name: "网络搜索" },
      //   { id: "学生推荐", name: "学生推荐" },
      //   { id: "合作方推荐", name: "合作方推荐" }
      // ], //来源
      purposelist: [
        { id: "兴趣", name: "兴趣" },
        { id: "留学", name: "留学" },
        { id: "就职", name: "就职" },
        { id: "高考日语", name: "高考日语" },
        { id: "考研辅导", name: "考研辅导" },
        { id: "在日升学", name: "在日升学" }
      ], //学习目的
      statelist: [
        { id: undefined, name: "请选择" },
        { id: "a", name: "a" },
        { id: "b", name: "b" },
        { id: "c", name: "c" },
        { id: "d", name: "d" },
        { id: "e", name: "e" },
        { id: "f", name: "f" }
      ], //资源状态
      japshowstuid: 0,
      teacherlist:[],//教学老师
      assignDialogVisible: false, //分配对话框显示
      assignForm: {
        resourceTypes: [] // 分配的资源类型：['鸣野']
      }, //分配表单
      followDialogVisible: false,
      followType: '',
      followDialogRow: null,
    };
  },
  methods: {
    canEditJap(row) {
      return user.canEditJap(row);
    },
    isMarketingOnlyJap(row) {
      return user.isMarketingOnlyJap(row);
    },
    isNoAdviserJap(row) {
      return user.isNoAdviserJap(row);
    },
    showLimitedOpJap(row) {
      return user.showLimitedOpJap(row);
    },
    openCourse(studentID) {
      var url = '/vue/japcourse?id=' + studentID;
      if (typeof window !== 'undefined' && window.open) {
        window.open(url, '_blank');
      }
    },
    handleSizeChange: function(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange: function(val) {
      this.currentPage4 = val;
      this.getList();
    },
    // 排序
    sortChange: function(sortColumn) {
      this.query.sort = sortColumn.sort;
      this.query.order = sortColumn.order;
      this.getList();
    },
    // 筛选
    filterTag: function(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      this.getList();
    },
    // 营销/顾问老师：不再按板块获取，直接获取所有启用用户；教学老师单独接口
    getTeacherList: function() {
      var _this = this;
      $.get(url.getStu("getenableusers"), {}, data => {
        var list = data || [];
        _this.marketlist = list;
        _this.adviserlist = list;
      });
      $.get(url.getStu("getteacher"), {}, data => {
        _this.teacherlist = data || [];
      });
    },
    // 学习课程
    getCourseList: function() {
      var _this = this;
      var link = url.getJap("getall_course");
      $.get(link, {}, data => {
        _this.courselist = data;
      });
    },
    // 地区
    getAreaList: function() {
      var _this = this;
      var link = url.getCommon("getareatwo");
      $.get(link, {}, data => {
        _this.arealist = data;
      });
    },
    // 省份列表（筛选用）
    getProvinceList() {
      var _this = this;
      var link = url.getCommon("getareabyname");
      $.get(link, {}, (data) => {
        _this.provinceList = data || [];
      });
    },
    // 来源
    getAllOrigin() {
      var _this = this;
      var link = url.getCommon("GetStuParam");
      $.get(link, {}, (data) => {
        _this.sourselist=data.originParam;
      });
    },
    // 列表
    getList: function() {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      if (_this.query.daterange) {
        params.start = _this.query.daterange[0];
        params.end = _this.query.daterange[1];
      } else {
        params.start = "";
        params.end = "";
      }
      params.pageSize = _this.pageSize;
      params.pageIndex = _this.currentPage4;
      var link = url.getJap("getlist_vip");
      $.get(link, params, data => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    // 查询
    selList: function() {
      this.currentPage4 = 1;
      this.getList();
    },
    // 按时间查看
    datelClick: function() {
      this.getList();
    },
    // 按顾问老师查询
    adviserClick: function() {
      this.getList();
    },
    // 导出（与列表同筛选，调用 VIP 导出接口）
    exportClick: function() {
      var _this = this;
      var params = Object.assign({}, _this.query);
      if (_this.query.daterange && _this.query.daterange.length >= 2) {
        params.start = _this.query.daterange[0];
        params.end = _this.query.daterange[1];
      }
      delete params.daterange;
      delete params.pageSize;
      delete params.pageIndex;
      var result = [];
      for (var item in params) {
        if (params[item] !== undefined && params[item] !== "" && params[item] !== null) {
          result.push(item + "=" + encodeURIComponent(params[item]));
        }
      }
      var link = url.getJap("exportjapvip") + "?" + result.join("&");
      window.open(link, "_blank");
    },
    // 编辑：从接口拉取完整日语资源数据，保证地区/性别/微信/学习目的/营销顾问正确回显
    editClick: function(row) {
      var _this = this;
      var studentID = row.studentID;
      var link = url.getJap("getmodel_base");
      $.get(link, { studentID: studentID }, function(data) {
        _this.form = data;
        _this.form.state = data.japState != null ? data.japState : data.state;
        _this.form.courseID = row.id; // 当前列表行对应课程记录 id，用于保存续费人、缴费时间、上课形式
        _this.form.renewerID = row.renewerID != null ? row.renewerID : null;
        _this.form.payTime = row.payTime || row.PayTime || null; // 当前行课程缴费时间，编辑可改
        // 当前行课程上课形式：intendedFormList 的 id 为字符串（网课/线下课等）；用 $set 保证响应式以便下拉回显
        var classFormVal = row.classForm != null ? row.classForm : (row.ClassForm != null ? row.ClassForm : '');
        _this.$set(_this.form, 'classForm', classFormVal);
        // 当前行学习课程名称，编辑时可修改
        _this.$set(_this.form, 'courseName', row.courseName != null ? row.courseName : (row.CourseName != null ? row.CourseName : ''));
        _this.selectedOptions = [];
        if (data.provinceID != null) _this.selectedOptions.push(data.provinceID);
        if (data.cityID != null) _this.selectedOptions.push(data.cityID);
        if (_this.form.intendedCourse) {
          _this.courseOptions = typeof _this.form.intendedCourse === "string" ? _this.form.intendedCourse.split(",") : [];
        } else {
          _this.courseOptions = [];
        }
        if (_this.renewerOptions.length === 0) {
          $.get(url.getJap("GetRenewerOptions"), function(opts) {
            _this.renewerOptions = opts || [];
          });
        }
        _this.dialogVisible = true;
      });
    },
    //编辑
    editClickFeel: function (row) {
      this.form = Object.assign({}, row);
      this.dialogVisiblefeel = true;
      console.log(this.form);
      //聊天图片
      this.imgList = [];
      if(this.form.imgList!=null){
        this.imgList = JSON.parse(this.form.imgList);
      }
    },
    //提交
    submitForm: function(formName) {
      var _this = this;
      var link = url.getJap("addorupdate_base");
      var info = this.form;
      info.provinceID = this.selectedOptions[0];
      info.cityID = this.selectedOptions[1];
      // 后端按 japState 同步主表 JpStatus，提交时带上避免保存后跟进状态被清空
      info.japState = info.state != null ? info.state : info.japState;

      info.intendedCourse = this.courseOptions.join();
      info.imgList = JSON.stringify(this.imgList);
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submiting = true;
          // 提交后台  添加或修改
          $.post(link, info, res => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.dialogVisiblefeel = false;
              _this.getList();
              _this.$message({ type: "success", message: res.msg });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 2026-01升级：老学员续费 - 打开续费对话框
    renewClick: function(row) {
      if (!row) return;
      var _this = this;
      _this.renewForm = {
        japID: row.studentID, // Crm_Japanese 主键为 StudentID
        courseName: '',
        payTime: '',
        coursePrice: '',
        amount1: '',
        amount2: '',
        amount3: '',
        phase1Date: '',
        phase2Date: '',
        phase3Date: '',
        percentage: '',
        classHour: '',
        classForm: '',
        startTime: '',
        endTime: '',
        renewerID: null // 续费人：选教务老师则算该老师签约，不选则当前顾问续费
      };
      _this.renewTeacherOptions = [];
      // 续费人下拉：顾问老师+教务老师（GetRenewerOptions）
      $.get(url.getJap('GetRenewerOptions'), {}, function(data) {
        _this.renewerOptions = data || [];
      });
      _this.renewDialogVisible = true;
    },
    // 2026-01升级：提交续费（与课程管理添加课程提交字段一致）
    submitRenew: function() {
      var _this = this;
      _this.$refs.renewFormRef.validate(function(valid) {
        if (!valid) return;
        _this.renewSubmiting = true;
        var link = url.getJap("renew_course");
        var params = {
          japID: _this.renewForm.japID,
          courseName: (_this.renewForm.courseName || '').trim(),
          coursePrice: Number(_this.renewForm.coursePrice) || 0,
          payTime: _this.renewForm.payTime,
          amount1: Number(_this.renewForm.amount1) || 0,
          amount2: Number(_this.renewForm.amount2) || 0,
          amount3: Number(_this.renewForm.amount3) || 0,
          percentage: Number(_this.renewForm.percentage) || 0,
          classHour: Number(_this.renewForm.classHour) || 1,
          classForm: _this.renewForm.classForm || '',
          teachers: Array.isArray(_this.renewTeacherOptions) ? _this.renewTeacherOptions.join() : ''
        };
        if (_this.renewForm.renewerID) params.renewerID = _this.renewForm.renewerID;
        if (_this.renewForm.phase1Date) params.phase1Date = _this.renewForm.phase1Date;
        if (_this.renewForm.phase2Date) params.phase2Date = _this.renewForm.phase2Date;
        if (_this.renewForm.phase3Date) params.phase3Date = _this.renewForm.phase3Date;
        if (_this.renewForm.startTime) params.startTime = _this.renewForm.startTime;
        if (_this.renewForm.endTime) params.endTime = _this.renewForm.endTime;
        $.post(link, params, function(res) {
          _this.renewSubmiting = false;
          if (res.status) {
            _this.$message({ type: 'success', message: res.msg || '续费成功' });
            _this.renewDialogVisible = false;
            _this.getList();
          } else {
            _this.$message({ type: 'error', message: res.msg || '续费失败' });
          }
        });
      });
    },
    dialogOpended() {
      var _this = this;
      /**截图上传**/
      if ($("#uploadBtn .uploader_text").length <= 0)
        $("#uploadBtn").uploader({
          url: url.getUpload(),
          fileExts: "jpg;png;jpeg",
          text: "选择图片",
          more: false, //是否可以上传多个
          auto: true, //是否自动上传
          type: "single", //指定处理类型
          max: 1024 * 1024 * 1,
          maxWidth: 2000,
          maxHeight: 2000,
          onSuccess: function (data) {
            //添加到列表,每个图片上传成功都会触发
            console.log(_this.imgList);
            
            _this.imgList.push(data.relativeName);
          },
        });
        if ($('#uploadBtn1 input').length == 0) {
          $('#uploadBtn1').uploader({
            url: url.getUpload(),
            text: '上传文件',
            fileExts: 'pdf;doc;docx',
            handleType: '0',
            onSuccess: function (data) {
              console.info(data)
              var src = url.getDomain() + data.relativeName
              _this.book = data.relativeName
              _this.form.book = data.relativeName
            }
            
          })
        }
        if ($("#uploadBtnConfig input").length == 0) {
        $("#uploadBtnConfig").uploader({
          url: url.getUpload(),
          text: "上传图片",
          fileExts: "jpg;png;jpeg",
          handleType: "0",
          maxSize: 1024 * 1024 * 0.5,
          onSuccess: function (data) {
            var src = url.getDomain() + data.relativeName;
            _this.$set(_this.form, "bookPhoto", data.relativeName);
          },
        });
      }
    },
    deleteImg(index){
      this.imgList.splice(index, 1);
    },
    showFollowDialog(type, row) {
      this.followType = type;
      this.followDialogRow = row && (row.studentID != null || row.id != null) ? { ...row, id: row.studentID || row.id } : (row || {});
      this.followDialogVisible = true;
    },
    // 分配
    assignClick: function(row) {
      if (!row) return;
      var _this = this;
      _this.assignForm = {
        studentID: row.studentID || row.id,
        realName: row.realName,
        isStudent: row.isStudent || false,
        isJap: row.isJap || false,
        isMingye: row.isMingye || false,
        resourceTypes: [],
        adviserID: row.adviserID || null,
        marketID: row.marketID || null,
        myAdviserID: row.myAdviserID || null,
        myMarketID: row.myMarketID || null
      };
      _this.assignDialogVisible = true;
    },
  },
  components: {
    JapaneseShow,
    OtherDeptFollow,
    FollowDetailDialog,
    AssignResourceDialog,
    DeptRoleTeacherSelect,
  },
  mounted() {
    this.getAllOrigin();
    this.getTeacherList();
    this.getCourseList();
    this.getAreaList();
    this.getProvinceList();
    this.getList();
  }
};
</script>

<style scoped>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
.el-input,
.el-select {
  width: 100%;
}
</style>